import { CircularProgress } from "@mui/material";
import { SpinnerWrapper } from "./styles";

const LoadingSpinner = () => (
  <SpinnerWrapper>
    <CircularProgress />
  </SpinnerWrapper>
);

export default LoadingSpinner;
